import styled from 'styled-components';

export const CardItem = styled.div`
  display: flex;
  flex-direction: column;
`;
